import { checkNewAppVersionInstalled } from '$logic/client-device'

export default () => {
  checkNewAppVersionInstalled()
}
